import { Action } from '@ngrx/store';
import { IUserColor } from '../IUserColor';
import { IUserInfo } from '../IUserInfo';
import { IUserAccess } from './user.reducer';

export enum UserActionTypes {
    LoadUserPermissions = '[user-info] Load User Permissions',
    SetUserPermissions = '[user-info] Set User Permissions',
    Logout = '[user-info] Logout',
    LoadUserInfo = '[user-info] Load User Info',
    LoadUserColors = '[user-info] Load User Colors',
    SetUserColors = '[user-info] Set User Colors',
    SetUserInfo = '[user-info] Set User Info',
    SetSignaturePolicy = '[user-info] Set Signature Policy'
}

export class LoadUserInfo implements Action {
    readonly type = UserActionTypes.LoadUserInfo;
}
export class SetUserInfo implements Action {
    readonly type = UserActionTypes.SetUserInfo;
    constructor(public payload: IUserInfo) {}
}
export class LoadUserColors implements Action {
    readonly type = UserActionTypes.LoadUserColors;
    constructor(public EmployeeListID: string) {}
}
export class SetUserColors implements Action {
    readonly type = UserActionTypes.SetUserColors;
    constructor(public payload: Array<IUserColor>) {}
}

export class LoadUserPermissions implements Action {
    readonly type = UserActionTypes.LoadUserPermissions;
}
export class SetUserPermissions implements Action {
    readonly type = UserActionTypes.SetUserPermissions;
    constructor(public payload: IUserAccess) {}
}

export class SetSignaturePolicy implements Action {
    readonly type = UserActionTypes.SetSignaturePolicy;
    constructor(public payload: IUserInfo) {}
}

export type UserActionsUnion =
    | LoadUserPermissions
    | SetUserPermissions
    | LoadUserInfo
    | SetUserInfo
    | LoadUserColors
    | SetUserColors
    | SetSignaturePolicy;
